var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyleIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7128_32616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 5.375L13.125 10.625M13.125 4.375L2.8125 9.625M3.75 1.875C4.78553 1.875 5.625 2.71447 5.625 3.75C5.625 4.78553 4.78553 5.625 3.75 5.625C2.71447 5.625 1.875 4.78553 1.875 3.75C1.875 2.71447 2.71447 1.875 3.75 1.875ZM3.75 9.375C4.78553 9.375 5.625 10.2145 5.625 11.25C5.625 12.2855 4.78553 13.125 3.75 13.125C2.71447 13.125 1.875 12.2855 1.875 11.25C1.875 10.2145 2.71447 9.375 3.75 9.375Z",
    stroke: "#818896",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7128_32616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleIconGray);
export default __webpack_public_path__ + "static/media/style-icon-gray.a5031563fd3c0a25b8ec27ef5b6c4010.svg";
export { ForwardRef as ReactComponent };